import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fill: '#51D61F',
  },
});

const LoadProgressIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 25 25" className={styles.icon}>
      <path d="M12.191 0C14.115 2.29436e-08 16.0108 0.462634 17.7186 1.34889C19.4263 2.23515 20.8959 3.51904 22.0034 5.09231C23.111 6.66559 23.824 8.4821 24.0823 10.3887C24.3407 12.2953 24.1368 14.236 23.4879 16.0473C22.839 17.8586 21.764 19.4873 20.3537 20.796C18.9434 22.1048 17.2391 23.0553 15.3844 23.5673C13.5298 24.0793 11.5793 24.1379 9.69724 23.738C7.81524 23.3382 6.05696 22.4917 4.57068 21.2699L7.24002 18.0227C8.20567 18.8165 9.34803 19.3665 10.5708 19.6263C11.7935 19.8861 13.0608 19.848 14.2658 19.5154C15.4708 19.1827 16.5781 18.5652 17.4944 17.7149C18.4107 16.8645 19.1091 15.8064 19.5307 14.6296C19.9523 13.4528 20.0848 12.1918 19.9169 10.9531C19.7491 9.71439 19.2858 8.53419 18.5662 7.51202C17.8467 6.48985 16.8918 5.65569 15.7823 5.07989C14.6728 4.50408 13.4411 4.2035 12.191 4.2035V0Z" />
      <circle cx="12.191" cy="12" r="3" />
    </SvgIcon>
  );
};

export default memo(LoadProgressIcon);
